
import { Observable } from 'rxjs';

// Create a map of names and matchMedia breakpoints.
const breakpoints = new Map([
  [ 'desktop', window.matchMedia('(min-width: 1024px)') ],
  // ['large', window.matchMedia('(min-width: 1280px)')],
  [ 'tablet', window.matchMedia('(max-width: 1023px)') ],
  [ 'mobile', window.matchMedia('(max-width: 727px)') ],
]);

// Get the last mq match and return corresponding name.
const getCurrentDevice = (bpValues) => {
  const bpMatches = Array.from(bpValues).filter(mq => mq.matches);
  const lastMatch = bpMatches.pop();

  return lastMatch ? lastMatch.name : null;
};

// Create an Observable that will react to changes in the breakpoints.
const device = new Observable(function(observer) {
  for (const [ name, mql ] of breakpoints) {
    // push name into MediaQueryList object.
    mql.name = name;
    // add listener to watch for future changes.
    mql.addListener((e) => {
      const name = getCurrentDevice(breakpoints.values());
      name && observer.next({ name, breakpoints, e });
    });
  }

  // emit current breakpoint name on initial subscription.
  const name = getCurrentDevice(breakpoints.values());
  observer.next({ name, breakpoints });

  // Any cleanup logic might go here
  return function() {
    console.log('disposed');
  };
});


export default device;
